import AlertModal from "@/components/common/AlertModal";
import AlertSocialsModal from "@/components/common/AlertSocialsModal";
import RequestAlert from "@/components/common/RequestAlert";
import { asyncModal } from "@/components/ui/modal/utils";

function showAlertFn(
  message,
  timeout = 0,
  showBtns = false,
  btnText = "OK",
  btnSide = "right",
  btnAction
) {
  return asyncModal({
    name: "app-alert-modal",
    component: AlertModal,
    props: {
      message,
      timeout,
      showBtns,
      btnText,
      btnSide,
      btnAction
    }
  });
}

export default showAlertFn;
export const showAlert = showAlertFn;

export const alertMessages = {
  request: "Во время выполнения запроса произошла ошибка."
};

export const requestErrorAlert = showAlertFn.bind(
  undefined,
  alertMessages.request
);

export function requestAlert(message = alertMessages.request, errors = []) {
  return asyncModal({
    name: "app-alert-modal",
    component: RequestAlert,
    closable: false,
    props: {
      message,
      errors
    }
  });
}

export function showSocialsAlert(
  message,
  timeout = 0,
  showBtns = false,
  btnText = "OK",
  btnSide = "right",
  btnAction
) {
  return asyncModal({
    name: "app-alert-modal",
    component: AlertSocialsModal,
    props: {
      message,
      timeout,
      showBtns,
      btnText,
      btnSide,
      btnAction
    }
  });
}
